import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const ExclusivesSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section exclusives-section main-hp hp-section">
      <div className="accesories-wrapper">
        <div className="accesories-products">
          <div className="accesories-product-wrap">
            {/* Background texture image */}
            <div className="texture">
              <picture>
                <source
                  srcSet="/images/homepage/exclusivesSection/bg-texture-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/exclusivesSection/bg-texture-dsktp.webp"
                  alt="Exclusives"
                  width={1920}
                  height={1290}
                />
              </picture>
            </div>

            {/* Main content */}
            <Link href={t('exclusivesLink')} className="accesories clearfix">
              <div className="outer-wrap">
                <div className="inner-wrap">
                  <div className="title">
                    <div className="inner-title">
                      <h2>{t('exclusivesHeading')}</h2>
                      <p>{t('exclusivesText')}</p>
                      <Button ariaLabel={t('exclusivesCta')}>{t('exclusivesCta')}</Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="branding-hero">
                <div className="img-wrap-tall">
                  <picture>
                    <source
                      srcSet="/images/homepage/exclusivesSection/kem-sofa-mob.webp"
                      media="(max-width: 768px)"
                    />
                    <img
                      src="/images/homepage/exclusivesSection/kem-sofa-dsktp.webp"
                      alt="Exclusives category"
                      width={1020}
                      height={715}
                    />
                  </picture>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExclusivesSection;
